import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9b10153c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./sytle.less?vue&type=style&index=0&id=9b10153c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b10153c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b10153c')) {
      api.createRecord('9b10153c', component.options)
    } else {
      api.reload('9b10153c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9b10153c&scoped=true&", function () {
      api.rerender('9b10153c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/jollybeans/index.vue"
export default component.exports